import React, { type ComponentProps, type ReactNode } from "react";
import { Dot } from "src/shared/formatters/Dot";

export interface IStatusFormatterProps
  extends Omit<ComponentProps<typeof Dot>, "color"> {
  status: "active" | "inactive" | "warning";
  children?: ReactNode;
  color?: string;
}

const StatusColorMap: Record<IStatusFormatterProps["status"], string> = {
  active: "#7ed321",
  warning: "#f5a623",
  inactive: "#cccccc",
};

export const StatusFormatter = ({ status, ...rest }: IStatusFormatterProps) => {
  return <Dot color={StatusColorMap[status] ?? "#cccccc"} {...rest} />;
};
